import { Steps, Button, Notification, toast } from 'components/ui'
export default function GetDropdownLabel(selectedKey, dropdowns) {
    return dropdowns
        ?.filter((e) => e?.value === selectedKey)
        .map((n) => n?.label)
}

export function GetErrorMsg(resp) {
    
    if (resp?.error?.validation_errors) {
        return resp?.message?.error?.validation_errors?.map(
            (item) => item.error_message
        )
    } 
    else if(resp?.message?.error?.validation_errors){
        return resp?.message?.error?.validation_errors?.map(
            (item) => item.error_message
        )
    }

    else if (!resp?.message?.success) {
        return resp?.message?.error?.error_msg
    } else {
        return resp?.error?.error_msg
    }
}


export function GetErrMsg(resp) {
    if (resp?.error?.validation_errors) {
       
        return resp?.message?.error?.validation_errors?.map(
            (item) => item.error_message
        )
    } else if (resp?.message?.success) {
        
        return resp?.message?.error?.error_msg
    } else {
       
        return resp?.error?.error_msg
    }
}


export const OpenNotification = (type, textTitle, setSubmitting) => {
    toast.push(
        <Notification
            title={type.charAt(0).toUpperCase() + type.slice(1)}
            type={type}
            duration={6000}
            width={"400px"}
        >
               {textTitle.charAt(0).toUpperCase() + textTitle.slice(1).toLowerCase()}
        </Notification>
    )
    // setSubmitting(false)
}

export const validateURL = (value) => {
    let errorMessage

    if (value) {
        const urlPattern =
            /^(http[s]?:\/\/)?(www\.)?([^\s.]+\.[^\s]{2,}|localhost)(\/[^\s]*)?$/
        if (!urlPattern.test(value)) {
            errorMessage = 'Invalid URL format'
        }
    }

    return errorMessage
}

export const snakeToCamel = (key) => {
    return key.replace(/(_\w)/g, function (match) {
        return match[1].toUpperCase()
    })
}
